<template>
  <div class="multi-video">
    <div data-test="info-window-content" v-if="videos">
      <div class="mb-2">
        <div v-if="oneOfVideosHasDownloadProblems">
          <div class="v-theme--light message-position">
            <div class="w-100 opacity-75 justify-content-center d-inline-flex bg-danger text-light p-3">
              {{ i18n.global.t('pages.cvr_uploads.errorMessages.failedLoadMovies') }}
            </div>
          </div>
        </div>
        <div
          v-else
          v-show="isAllVideosReadyToAutoPlay"
          class="bg-black mb-2"
        >
          <div class="container">
            <div class="row">
              <div :class="mainVideoClass" v-if="mainVideo">
                 <MultiVideoPart
                   :globalTimeLinePosition="timeLinePosition"
                   :seekedTimeLinePosition="seekedTimeLinePosition"
                   :key="0"
                   :videoID="mainVideo.job_id"
                   :src="mainVideo.src"
                   :isMainVideo="true"
                   :allVideosArePlaying="allVideosArePlaying"
                   :isAllVideosReadyToAutoPlay="isAllVideosReadyToAutoPlay"
                   :oneOfVideosIsWaiting="oneOfVideosIsWaiting"
                   @isPlayingStateChange="(state) => (allVideosArePlaying = state)"
                   @videoTimeupdate="changeTimelinePositionEvent"
                   @videoSeeked="videoSeekedEvent"
                   @isReadyToPlay="videoReadyToPlayEvent"
                   @videoIsWaiting="addVideoInWaitingList"
                   @videoIsNotWaiting="removeVideoFromWaitingList"
                   @videoCanNotBePlayed="addVideoToErrorList"
                 />
              </div>
              <div :class="subVideoClass">
                <MultiVideoPart
                  v-for="(video, index) in arSubVideos"
                  :globalTimeLinePosition="timeLinePosition"
                  :seekedTimeLinePosition="seekedTimeLinePosition"
                  :key="index + 1"
                  :videoID="video.job_id"
                  :src="video.src"
                  :isMainVideo="false"
                  :allVideosArePlaying="allVideosArePlaying"
                  :isAllVideosReadyToAutoPlay="isAllVideosReadyToAutoPlay"
                  :oneOfVideosIsWaiting="oneOfVideosIsWaiting"
                  @isPlayingStateChange="(state) => (allVideosArePlaying = state)"
                  @videoTimeupdate="changeTimelinePositionEvent"
                  @videoSeeked="videoSeekedEvent"
                  @isReadyToPlay="videoReadyToPlayEvent"
                  @videoIsWaiting="addVideoInWaitingList"
                  @videoIsNotWaiting="removeVideoFromWaitingList"
                  @videoCanNotBePlayed="addVideoToErrorList"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-show="!videos || !isAllVideosReadyToAutoPlay"
      class="video-loading"
    >
      <div class="loading">
        <div class="max-w-md w-full space-y-8">
          <v-loader-animation
            text="text-black"
            loading-text-style="text-black text-lg"
            :loading-text="loadingText"
            :addCharacterImg="false"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import vLoaderAnimation from '@/components/template/v-loader-animation.vue';
import MultiVideoPart from '@/components/CvrConvert/MultiVideoPart.vue'
import { timeLinePosition, timeLineProducer } from '@/types/timeLinePosition'
import Api from "@/services/api/ApiServiceFabrick";
import i18n from '@/lang/i18n';

export default defineComponent({
  setup() {
    return {
      i18n
    }
  },
  name: 'MultiVideo',
  props: {
    item: {},
    addError: Function,
  },
  data() {
    return {
      loadingText: "loading...",
      timeLinePosition: {
        positionInPercentage: 0,
        producer: timeLineProducer.CONTAINER,
        producerID: 0,
      },
      seekedTimeLinePosition: {
        positionInPercentage: 0,
        producer: timeLineProducer.CONTAINER,
        producerID: 0,
      },
      allVideosArePlaying: false,
      arReadyToPlayVideoIDs: [],
      arWaitingVideoIDs: [],
      arErrorVideoIDs: [],
      videos: null,
      dialogState: false,
    }
  },
  computed: {
    mainVideo() {
      let videos = this.videos ?? []
      let video = null;
      this.videos.forEach((v) => {
        if (v.type === 'F') {
          video = JSON.parse(JSON.stringify(v))
        }
      })
      return video
    },
    mainVideoClass() {
      if (this.arSubVideos.length == 0) {
        return 'col-md-12'
      } else if (this.arSubVideos.length == 1) {
        return 'col-md-6'
      } else if (this.arSubVideos.length == 2) {
        return 'col-md-8'
      }
      return 'col-md-9'
    },
    arSubVideos() {
      let videos = [];
      this.videos.forEach((v) => {
        if (v.type !== 'F') {
          const video = JSON.parse(JSON.stringify(v))
          videos.push(video)
        }
      })
      return videos
    },
    subVideoClass() {
      if (!this.mainVideo) {
        return 'd-flex'
      } else if (this.arSubVideos.length == 1) {
        return 'col-md-6'
      } else if (this.arSubVideos.length == 2) {
        return 'col-md-4'
      }
      return 'col-md-3'
    },
    isAllVideosReadyToAutoPlay() {
      return (
        this.arReadyToPlayVideoIDs.length === this.arVideoWithOutError.length
      )
    },
    oneOfVideosIsWaiting() {
      return this.arWaitingVideoIDs.length > 0
    },
    arVideoWithOutError() {
      if (!this.videos?.length) {
        return []
      }
      return this.videos.filter((video) => {
        const index = this.arErrorVideoIDs.indexOf(video.job_id)
        return index === -1
      })
    },
    oneOfVideosHasDownloadProblems() {
      return this.arErrorVideoIDs.length > 0
    },
    isContentPreparingToBeShown() {
      return (
        !this.oneOfVideosHasDownloadProblems && !this.isAllVideosReadyToAutoPlay
      )
    },
  },
  mounted() {
    this.getVideos();
  },
  watch: {
    item: {
      handler() {
        this.getVideos();
      },
    }
  },
  methods: {
    changeTimelinePositionEvent(timelinePosition) {
      if (
        this.timeLinePosition.positionInPercentage !=
        timelinePosition.positionInPercentage
      ) {
        this.timeLinePosition = timelinePosition
      }
    },
    videoSeekedEvent(timelinePosition) {
      if (
        this.seekedTimeLinePosition.positionInPercentage !=
        timelinePosition.positionInPercentage
      ) {
        this.seekedTimeLinePosition = timelinePosition
      }
    },
    videoReadyToPlayEvent(videoID) {
      const index = this.arReadyToPlayVideoIDs.indexOf(videoID)
      if (index == -1) {
        this.arReadyToPlayVideoIDs.push(videoID)
      }
    },
    addVideoToErrorList(videoID) {
      const index = this.arErrorVideoIDs.indexOf(videoID)
      if (index !== -1) {
        return
      }

      this.arErrorVideoIDs.push(videoID)
    },
    addVideoInWaitingList(videoID) {
      const index = this.arWaitingVideoIDs.indexOf(videoID)
      if (index == -1) {
        this.arWaitingVideoIDs.push(videoID)
      }
    },
    removeVideoFromWaitingList(videoID) {
      const index = this.arWaitingVideoIDs.indexOf(videoID)
      if (index == -1) return
      this.arWaitingVideoIDs.splice(index, 1)
    },
    async getVideos() {
      let children = this.item.children ?? []
      let _videos = []
      if (!children[0]) {
        const video = JSON.parse(JSON.stringify(this.item))
        video.type = 'F'
        _videos.push(video)
      } else {
        _videos = children
      }
      const videos = []
      _videos.forEach((video) => {
        if (video.status.toLowerCase() == 'complete') videos.push(video)
      })

      const urls = await Promise.all(
        (videos ?? []).map((video) => {
          return this.getSrc(video.job_id);
        })
      );
      videos.forEach((video, i) => {
        video.src = urls[i];
      })
      this.videos = videos
    },
    async getSrc(jobId) {
      return Api().getCvrUploadPresignedUrl(jobId)
    },
  },
  components: {
    MultiVideoPart,
    vLoaderAnimation,
  },
})
</script>

<style scoped>
.video-loading {
  margin: 1% 3%;
  height: 100%;
  background-color: rgba(80,80,80,0.5);
  height: 40vh;
}
.video-loading .loading{
  height: 100%;
  width: 100%;
}
.loading {
  display: flex;
  align-items: center;
  justify-content: center;
}
.multi-video {
  min-height: 40vh;
}
</style>
